module.exports = __webpack_public_path__ + "static/img/hp-web-committee.c9cf2dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/hp-web-committee.svg?4bhrm4
// module id = gAx2
// module chunks = 1